import { FormTextField } from 'ui';

export interface BaseWidgetFormFields {
  name: string;
}

export const BaseWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return <FormTextField id="name" name="name" label="Name" fullWidth />;
};
